import { MAPICONS, getMapIconName, processNameToShortCode, isZonedSchool } from '../utils/helpers';
import messages from '../locale/messages';

export default function (normalSchools, resultIds = [], admissionProcess = '') {
  const results = [];
  for (let id of resultIds) {
    let school;
    if (!isNaN(+id.toString())) //it is school_id
      school = normalSchools.entities.school[id];
    else { //it is dbn
      id = id.toUpperCase();
      school = Object.values(normalSchools.entities.school).filter(item => item.school.dbn == id)[0];
    }
    if (school.latlong.lat && school.latlong.lng) {
      let icon = 'defaultEligibility';
      let overwriteInnerShapeBy = undefined;
      if (school.getSavedPrograms && school.getSavedPrograms().length) {
        icon = 'savedPrograms';
        overwriteInnerShapeBy = MAPICONS.OverwriteImages.Favorite;
      }
      if (school.getSavedApplications() && school.getSavedApplications().length) {
        icon = 'savedApplications';
        overwriteInnerShapeBy = MAPICONS.OverwriteImages.Applied;
      }

      if (!admissionProcess) {
        const parts = window.location.pathname.split('/');
        const processName = parts.pop() || parts.pop();
        // eslint-disable-next-line no-param-reassign
        admissionProcess = processNameToShortCode({ processName });
      }
      const isPK = window.App.state.user.admissionProcess === 'PK' || admissionProcess === 'PK';
      const is2K = window.App.state.user.admissionProcess === '2K' || admissionProcess === '2K';
      const is3K = window.App.state.user.admissionProcess === '3K' || admissionProcess === '3K';
      const isGiftedAndTalented = window.App.state.user.admissionProcess === 'GTAPP' || admissionProcess === 'GTAPP';
      const isMiddleSchool = window.App.state.user.admissionProcess === 'MS' || admissionProcess === 'MS';
      const isSR = window.App.state.user.admissionProcess === 'SR' || admissionProcess === 'SR';
      let title = school.title;
      if (!isGiftedAndTalented && !isMiddleSchool) {
        const isSpecializedHighSchool = school.admission_process === 'SHS'
        const isLaGuardia = school.admission_process === 'LG'
        if (isSpecializedHighSchool || isLaGuardia) {
          icon = MAPICONS.SpecializedSchoolsIcon;
        }
        else if (isSR && school.isAffiliatedSRLocation) {
          icon = MAPICONS.AffiliatedSchoolsIcon;
          title = 'Affiliated ' + title
        }
        else {

          icon = getMapIconName(school.eligibility, school.other_features);
          if (icon == MAPICONS.MultipleEligibilityMapIcon) {
            if (overwriteInnerShapeBy == MAPICONS.OverwriteImages.Favorite) {
              overwriteInnerShapeBy = icon + "-" + MAPICONS.OverwriteImages.Favorite;
            }
            else if (overwriteInnerShapeBy == MAPICONS.OverwriteImages.Applied) {
              overwriteInnerShapeBy = icon + "-" + MAPICONS.OverwriteImages.Applied;
            }
          }
        }
      }
      if (isZonedSchool(school.school.dbn, admissionProcess)) {
        icon = MAPICONS.ZonedSchoolIcon;
        title = messages.generalStringZoned.defaultMessage + ' ' + title;
      }
      let schoolPrograms = false;
      if (school.programs.result.length !== 0) {
        schoolPrograms = Object.keys(school.programs.entities.program)
          .filter(programId => school.programs.entities.program[programId].saved === true)
          .map(programId => ({
            name: school.programs.entities.program[programId].name,
            id: programId,
            schoolId: id,
          }));
      }
      results.push({
        id,
        lat: school.latlong.lat,
        lng: school.latlong.lng,
        icon,
        label: title,
        overwriteInnerShapeBy: overwriteInnerShapeBy,
        popup: {
          distance: school.distance,
          gradesDescription: school.grades_description,
          accessibility: school.accessibility,
          id,
          name: title,
          schoolAddress: school.info.address,
          programs: schoolPrograms,
          eligibility: school.eligibility,
          isPK,
          is2K,
          is3K,
          dbn: school.school.dbn,
          icon: icon
        },
      });
    }
  }
  return results;
}
